import { Controller } from "@hotwired/stimulus"
import { UNITS_KEY, CURRENCY_KEY, SYMBOLS, getUnits, getCurrency, applyPreferences, keepPreferencesApplied } from "../lib/preferences"

// Header m | ft toggle and currency menu. Changes are remembered and announced with
// ge:units-changed / ge:currency-changed so any page can follow along.
export default class extends Controller {
  static targets = ["panel", "unitBtn", "unitOption", "currencyOption", "currencyLabel", "chipLabel"]

  connect() {
    this.onOutsideClick = (event) => { if (!this.element.contains(event.target)) this.close() }
    this.onEscape = (event) => { if (event.key === 'Escape') this.close() }
    document.addEventListener('click', this.onOutsideClick)
    document.addEventListener('keydown', this.onEscape)
    // A second toggle elsewhere on the page changes the same setting, so follow it
    this.onChanged = () => this.render()
    window.addEventListener('ge:units-changed', this.onChanged)
    window.addEventListener('ge:currency-changed', this.onChanged)
    keepPreferencesApplied()
    this.render()
  }

  disconnect() {
    document.removeEventListener('click', this.onOutsideClick)
    document.removeEventListener('keydown', this.onEscape)
    window.removeEventListener('ge:units-changed', this.onChanged)
    window.removeEventListener('ge:currency-changed', this.onChanged)
  }

  toggle() {
    this.panelTarget.hidden = !this.panelTarget.hidden
  }

  close() {
    if (this.hasPanelTarget) this.panelTarget.hidden = true
  }

  setUnits(event) {
    localStorage.setItem(UNITS_KEY, event.params.units)
    this.render()
    window.dispatchEvent(new CustomEvent('ge:units-changed'))
  }

  setCurrency(event) {
    localStorage.setItem(CURRENCY_KEY, event.params.code)
    this.render()
    window.dispatchEvent(new CustomEvent('ge:currency-changed'))
  }

  render() {
    const units = getUnits()
    const currency = getCurrency()

    this.unitBtnTargets.forEach(btn => btn.classList.toggle('ge-prefs__unit--on', btn.dataset.preferencesUnitsParam === units))
    this.unitOptionTargets.forEach(el => el.setAttribute('aria-checked', String(el.dataset.preferencesUnitsParam === units)))
    this.currencyOptionTargets.forEach(el => el.setAttribute('aria-checked', String(el.dataset.preferencesCodeParam === currency)))
    if (this.hasCurrencyLabelTarget) this.currencyLabelTarget.textContent = `${SYMBOLS[currency]} ${currency}`
    if (this.hasChipLabelTarget) this.chipLabelTarget.textContent = `${SYMBOLS[currency]} · ${units}`
    applyPreferences()
  }
}
